var _a;
// Types
import { ButtonShape } from '../../../common/types/ButtonShape';
export var IconButtonStylePropertiesByShape = (_a = {},
    _a[ButtonShape.CIRCLE] = {
        borderRadius: '100%',
    },
    _a[ButtonShape.SQUARE] = {
        borderRadius: '4px',
    },
    _a);
//# sourceMappingURL=IconButtonStylePropertiesByShape.js.map